import _ from 'lodash';
import { BrokerConfigs } from 'v3/pages/LandingPage/Default/BannerSection/UserAuth/LoginModal/types.type';

export const BROKERS: BrokerConfigs = _.get(window, 'brokerConfigs', {});
